import React from 'react';

const PartnerCategoryModal = ({ isOpen, onClose, category }) => {
    if (!isOpen) return null;

    const categoryContent = {
        distributors: {
            title: 'Distributors',
            description: 'Become a distributor and expand your business with HAV\'N Interiors',
            benefits: [
                'Access to premium product portfolio',
                'Exclusive territory rights',
                'Marketing and branding support',
                'Training and technical assistance',
                'Competitive pricing and margins'
            ],
            requirements: [
                'Minimum 2000 sq.ft showroom space',
                'Experience in interior design or related industry',
                'Strong local market presence',
                'Financial capability for inventory investment'
            ]
        },
        cluster: {
            title: 'Cluster Distributors',
            description: 'Lead multiple locations and build a regional network',
            benefits: [
                'Multi-location distribution rights',
                'Higher profit margins',
                'Priority product launches',
                'Dedicated account manager',
                'Regional marketing support'
            ],
            requirements: [
                'Proven track record in distribution',
                'Ability to manage multiple locations',
                'Strong logistics infrastructure',
                'Significant investment capability'
            ]
        },
        franchises: {
            title: 'Franchises',
            description: 'Own and operate a HAV\'N Interiors branded outlet',
            benefits: [
                'Established brand recognition',
                'Complete business setup support',
                'Comprehensive training program',
                'Ongoing operational guidance',
                'National marketing campaigns'
            ],
            requirements: [
                'Prime location for showroom',
                'Commitment to brand standards',
                'Investment in franchise setup',
                'Passion for interior design'
            ]
        },
        dealers: {
            title: 'Dealers',
            description: 'Partner with us as an authorized dealer',
            benefits: [
                'Flexible business model',
                'Product training and support',
                'Marketing materials provided',
                'Competitive dealer pricing',
                'Growth opportunities'
            ],
            requirements: [
                'Retail or showroom space',
                'Basic industry knowledge',
                'Customer service focus',
                'Initial inventory investment'
            ]
        }
    };

    const content = categoryContent[category] || categoryContent.distributors;

    return (
        <div 
            className="partner-category-modal-overlay"
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000,
                padding: '20px',
                backdropFilter: 'blur(5px)'
            }}
        >
            <div 
                className="partner-category-modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: 'linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%)',
                    borderRadius: '20px',
                    padding: '50px',
                    maxWidth: '800px',
                    width: '100%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    position: 'relative',
                    border: '2px solid rgba(201, 169, 110, 0.3)',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
                }}
            >
                {/* Close Button */}
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        background: 'rgba(201, 169, 110, 0.2)',
                        border: '1px solid rgba(201, 169, 110, 0.4)',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        color: 'var(--accent-color)',
                        fontSize: '24px',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(201, 169, 110, 0.3)';
                        e.target.style.transform = 'rotate(90deg)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(201, 169, 110, 0.2)';
                        e.target.style.transform = 'rotate(0deg)';
                    }}
                >
                    ✕
                </button>

                {/* Header */}
                <div style={{ marginBottom: '30px', textAlign: 'center' }}>
                    <h2 style={{
                        fontSize: '36px',
                        color: 'var(--accent-color)',
                        marginBottom: '15px',
                        fontWeight: '300'
                    }}>
                        {content.title}
                    </h2>
                    <p style={{
                        fontSize: '18px',
                        color: 'rgba(245, 241, 237, 0.8)',
                        lineHeight: '1.6'
                    }}>
                        {content.description}
                    </p>
                </div>

                {/* Benefits Section */}
                <div style={{ marginBottom: '40px' }}>
                    <h3 style={{
                        fontSize: '24px',
                        color: 'var(--accent-color)',
                        marginBottom: '20px',
                        fontWeight: '400'
                    }}>
                        Benefits
                    </h3>
                    <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0
                    }}>
                        {content.benefits.map((benefit, index) => (
                            <li key={index} style={{
                                fontSize: '16px',
                                color: 'rgba(245, 241, 237, 0.9)',
                                marginBottom: '15px',
                                paddingLeft: '30px',
                                position: 'relative',
                                lineHeight: '1.6'
                            }}>
                                <span style={{
                                    position: 'absolute',
                                    left: 0,
                                    color: 'var(--accent-color)',
                                    fontSize: '20px'
                                }}>
                                    ✓
                                </span>
                                {benefit}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Requirements Section */}
                <div style={{ marginBottom: '40px' }}>
                    <h3 style={{
                        fontSize: '24px',
                        color: 'var(--accent-color)',
                        marginBottom: '20px',
                        fontWeight: '400'
                    }}>
                        Requirements
                    </h3>
                    <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0
                    }}>
                        {content.requirements.map((requirement, index) => (
                            <li key={index} style={{
                                fontSize: '16px',
                                color: 'rgba(245, 241, 237, 0.9)',
                                marginBottom: '15px',
                                paddingLeft: '30px',
                                position: 'relative',
                                lineHeight: '1.6'
                            }}>
                                <span style={{
                                    position: 'absolute',
                                    left: 0,
                                    color: 'var(--accent-color)',
                                    fontSize: '20px'
                                }}>
                                    •
                                </span>
                                {requirement}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* CTA Section */}
                <div style={{
                    textAlign: 'center',
                    paddingTop: '30px',
                    borderTop: '1px solid rgba(201, 169, 110, 0.2)'
                }}>
                    <p style={{
                        fontSize: '16px',
                        color: 'rgba(245, 241, 237, 0.8)',
                        marginBottom: '20px'
                    }}>
                        Ready to join our network?
                    </p>
                    <button
                        onClick={() => {
                            onClose();
                            // Scroll to partner form or open it
                            const partnerSection = document.querySelector('.partner-cta-btn');
                            if (partnerSection) {
                                partnerSection.click();
                            }
                        }}
                        style={{
                            padding: '15px 40px',
                            background: 'linear-gradient(135deg, #C9A96E 0%, #B8935A 100%)',
                            color: '#000',
                            border: 'none',
                            borderRadius: '50px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(201, 169, 110, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 6px 20px rgba(201, 169, 110, 0.5)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 15px rgba(201, 169, 110, 0.3)';
                        }}
                    >
                        Apply Now
                    </button>
                </div>
            </div>

            {/* Custom Scrollbar Styles */}
            <style jsx>{`
                .partner-category-modal-content::-webkit-scrollbar {
                    width: 8px;
                }
                
                .partner-category-modal-content::-webkit-scrollbar-track {
                    background: rgba(201, 169, 110, 0.1);
                    border-radius: 10px;
                }
                
                .partner-category-modal-content::-webkit-scrollbar-thumb {
                    background: rgba(201, 169, 110, 0.5);
                    border-radius: 10px;
                }
                
                .partner-category-modal-content::-webkit-scrollbar-thumb:hover {
                    background: var(--accent-color);
                }
            `}</style>
        </div>
    );
};

export default PartnerCategoryModal;

